import {
    GET_INCIDENT_REPORTS,
    GET_INCIDENT_REPORTS_SUCCESS,
    GET_INCIDENT_REPORTS_FAILURE,
    SET_INCIDENT_REPORT_FILTERS,
    RESET_INCIDENT_REPORT_FILTERS
} from '../actions/types';

export const INITIAL_FILTERS = {
    severity: '',
    category: '',
    status: '',
    review_stage: '',
    is_violation: '',
    guard_id: '',
    location_id: '',
    property_id: '',
    from: null,
    to: null
};

const INITIAL_STATE = {
    reports: [], // every incident report the org has — filtering happens client-side
    loading: false,
    error: null,
    filters: INITIAL_FILTERS
};

const toMillis = timestamp =>
    typeof timestamp?.seconds === 'number' ? timestamp.seconds * 1000 : null;

const startOfDayMs = date => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
const endOfDayMs = date => startOfDayMs(date) + 24 * 60 * 60 * 1000 - 1;

// Pure derivation of the visible rows from raw state — mirrors findInboxForOrg's
// filters (sage-nest-api's incident-report.service.ts), applied client-side over data
// the saga already loaded, so the filter panel never re-subscribes the live listener.
export const filterIncidentReports = (reports, filters = INITIAL_FILTERS) => {
    return (reports || []).filter(report => {
        if (filters.status && report.status !== filters.status) return false;
        if (filters.review_stage && report.review_stage !== filters.review_stage) return false;
        if (filters.severity && report.severity !== filters.severity) return false;
        if (filters.category && report.category !== filters.category) return false;

        if (filters.is_violation === 'true' && !report.is_violation) return false;
        if (filters.is_violation === 'false' && report.is_violation) return false;

        if (filters.guard_id && report.guard_id !== filters.guard_id) return false;
        if (filters.location_id && report.location_id !== filters.location_id) return false;
        if (filters.property_id && report.property_id !== filters.property_id) return false;

        if (filters.from || filters.to) {
            const ms = toMillis(report.reported_at);
            if (ms === null) return false;
            if (filters.from && ms < startOfDayMs(filters.from)) return false;
            if (filters.to && ms > endOfDayMs(filters.to)) return false;
        }

        return true;
    });
};

const incidentReportsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_INCIDENT_REPORTS:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_INCIDENT_REPORTS_SUCCESS:
            return {
                ...state,
                loading: false,
                reports: action.payload
            };
        case GET_INCIDENT_REPORTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case SET_INCIDENT_REPORT_FILTERS:
            return {
                ...state,
                filters: action.payload
            };
        case RESET_INCIDENT_REPORT_FILTERS:
            return {
                ...state,
                filters: INITIAL_FILTERS
            };

        default:
            return state;
    }
};

export default incidentReportsReducer;
